import React from 'react';
import SubCondition from './SubCondition/SubCondition';

import AddField from './AddField/AddField';

function ConditionGroup(props) {
    const {className = '', condition, category, children, onAddSubCondition, onRemoveSubCondition, onOperatorChange, onAddValue, onChangeValue, onReplaceField} = props;

    // TODO: add here the requiredUserActions

    return (
        <div className={['well', 'well-sm', 'ANDGroup', className].join(' ')}>
            {condition.OR.map((subCondition, i) => (
                <SubCondition
                    key={i}
                    category={category}
                    subCondition={subCondition}
                    onRemoveSubCondition={() => onRemoveSubCondition(i)}
                    onOperatorChange={operator => onOperatorChange(i, operator)}
                    onAddValue={value => onAddValue(i, value)}
                    onChangeValue={(valueIndex, value) => onChangeValue(i, valueIndex, value)}
                    onReplaceField={field => onReplaceField(i, field)}
                />
            ))}
            <AddField condition={condition} onAddSubCondition={onAddSubCondition} />
            {children}
        </div>
    );
}

export default ConditionGroup;
